module.exports = __webpack_public_path__ + "img/chest-8.4ac80a26.png";